import React, { useEffect } from "react";
import { Modal, Form, Select, Button, Input } from "antd";
import { useGlobalContext } from "../../../context/GlobalContext";
import useSet from "../../../hooks/common/useSet";
import { API_DISBURSEMENT_SETTINGS } from "../../../utils/apis";
import toast from "react-hot-toast";

const DisbursementSettings = () => {
  const { data: globalData, updateData } = useGlobalContext();
  const { openDisbursementSettings } = globalData || {};
  const [form] = Form.useForm();
  const {
    uploadData,
    submitting,
    error: submitError,
    success: submitSuccess,
    data: responseData,
  } = useSet();

  const handleClose = () => {
    updateData({ openDisbursementSettings: false });
    form.resetFields();
  };

  useEffect(() => {
    if (submitSuccess && responseData) {
      toast.success("Disbursement settings updated successfully");
      updateData({ openDisbursementSettings: false });
      form.resetFields();
    }
  }, [submitSuccess, responseData]);

  useEffect(() => {
    if (
      submitError &&
      Object.keys(submitError).length > 0 &&
      !submitError.notSubmit
    ) {
      const errorMessage =
        (typeof submitError?.message === "string"
          ? submitError.message
          : null) ||
        (typeof submitError?.detail === "string" ? submitError.detail : null) ||
        "Failed to generate API key";
      toast.error(errorMessage);
    }
  }, [submitError]);

  const handleSubmit = (values: any) => {
    uploadData({
      api: API_DISBURSEMENT_SETTINGS,
      data: {
        merchant_number: values.merchantId,
      },
    });
  };

  return (
    <Modal
      open={!!openDisbursementSettings}
      onCancel={handleClose}
      title="Disbursement Settings"
      footer={null}
      centered
      width={500}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        autoComplete="off"
      >
        <Form.Item
          label="Hmac Secret"
          name="hmacSecret"
          rules={[{ required: true, message: "Please enter HmacSecret" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Value"
          name="value"
          rules={[{ required: true, message: "Please enter value" }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Is Encrypted"
          name="is_encrypted"
          rules={[{ required: true, message: "Please enter is_encrypted" }]}
        >
          <Select>
            <Select.Option value={true}>True</Select.Option>
            <Select.Option value={false}>False</Select.Option>
          </Select>
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" loading={submitting}>
            Save
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default DisbursementSettings;
